/* eslint-disable sort-keys */
import { BEFORE_UNLOAD_LABELS } from '~/definitions/labels';

const cleanSessionStorage = (shouldClearMapping: boolean = true) => {
  if (shouldClearMapping) {
    sessionStorage.removeItem('mapping');
  }
};

export const submitFileStatusUpdateInBackground = (shouldClearMapping?: boolean) => {
  const body = localStorage.getItem('moderationData');
  localStorage.removeItem('moderationData');

  cleanSessionStorage(shouldClearMapping);

  if (body) {
    if (!navigator.sendBeacon('/proxy/content/update-file-status', body)) {
      // Fallback to fetch with keepalive if sendBeacon fails
      fetch('/proxy/content/update-file-status', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: body,
        keepalive: true,
      });
    }
  }
};

export const handleUnsavedProgress = (shouldClearMapping?: boolean) => {
  const isUnsavedProgress = localStorage.getItem('isUnsavedProgress');
  const value = isUnsavedProgress ? JSON.parse(isUnsavedProgress) : null;
  localStorage.removeItem('isUnsavedProgress');

  //make submitFileStatusUpdateInBackground only if there're any unsaved changes
  if (isUnsavedProgress && value.isUnsavedProgress === true) {
    // eslint-disable-next-line no-alert
    const confirmLeave = window.confirm(BEFORE_UNLOAD_LABELS.BEFORE_UNLOAD);
    if (confirmLeave) {
      submitFileStatusUpdateInBackground(shouldClearMapping);
      return true;
    } else {
      return false;
    }
  } else {
    submitFileStatusUpdateInBackground(shouldClearMapping);
    return true;
  }
};
